<template>
  <div class="compare-products-popup">
    <div class="modal" :class="open ? 'show fade' : ''">
      <div class="modal-dialog container-fluid">
        <div class="modal-content">
          <div class="mt-4">
            <div class="pop-up-modal-block">
              <div class="modal-header">
                <p class="pop-up-modal-header secondary-heading">
                  {{ $resourceString["product.details.compare.title"] }}
                </p>
                <button class="wf-modal-button-close btn button-full"
                        type="button"
                        @click="closeModal">
                  <span class="png-icon png-icon-icons-symbols--k-txtclose"
                        aria-label="Close modal" />
                </button>
              </div>
              <div class="modal-body">
                <div class="row mt-1 mb-5">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-lg-4 col-12">
                        <p class="swatch-count">
                          {{ getCompareProducts.length }}
                          {{
                            $resourceString[
                              "product.details.compare.selectedswatches"
                            ]
                          }}
                        </p>
                      </div>
                      <div class="col">
                        <div class="pop-up-left-btn-group row w-100 text-right justify-content-center justify-content-md-end">
                          <button class="col btn btn-white border-dark mt-1 mb-2 mx-2"
                                  @click="removeAllCompareProduct">
                            <span class="mr-3">
                              {{ $resourceString["common.removeAll"] }}
                            </span>
                            <span class="png-icon png-icon-icons-glyph--k-close" />
                          </button>
                          <button class="col btn btn-white border-dark mt-1 mb-2 mx-2"
                                  @click="copyComparisonUrl">
                            <span class="mr-3">
                              <template v-if="flash">
                                {{ $resourceString["common.linkCopiedText"] }}
                              </template>
                              <template v-else>
                                {{
                                  $resourceString["common.copyLinkButtonText"]
                                }}
                              </template>
                            </span>
                            <span class="png-icon png-icon-icons-glyph--k-link" />
                          </button>
                          <button class="col download-action-button btn btn-white border-dark mt-1 mb-2 mx-2"
                                  @click="downloadProducts">
                            <span class="mr-3">
                              {{ $resourceString["common.download"] }}
                            </span>
                            <span class="png-icon png-icon-icons-glyph--k-btn-download" />
                          </button>
                          <button class="col download-action-button btn btn-white border-dark mt-1 mb-2 mx-2"
                                  @click="pdfDownload"
                                  v-if="allowPdfRender">
                            <span class="mr-3">
                              {{ $resourceString["product.search.pdf.download.button.title"] }}
                            </span>
                            <span class="png-icon png-icon-icons-glyph--k-btn-download" />
                          </button>
                          <button type="button"
                                  class="col pop-up-add-to-cart-button btn btn-primary mt-1 mb-2 mx-2"
                                  @click="addToCart"
                                  :disabled="disableAddToCart">
                            <span class="png-icon png-icon-icons-glyph--ko-my-basket" />
                            <span class="ml-2">
                              {{ $resourceString["common.addtobasket"] }}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 w-100 h-100">
                    <VueSlickCarousel v-if="
                                      !fetchingCompareProducts &&
                                      getCompareProducts.length>
                      0
                      "
                      v-bind="settings"
                      >
                      <template #nextArrow>
                        <button type="button" class="custom-arrow-next"><span class="png-icon png-icon-icons-glyph--k-chevron-right"></span></button>
                      </template>
                      <template #prevArrow>
                        <button type="button" class="custom-arrow-prev"><span class="png-icon png-icon-icons-glyph--k-chevron-left"></span></button>
                      </template>
                      <div v-for="(item, index) in getCompareProducts"
                           :key="item.sellingStyleNumber"
                           class="compare-products">
                        <div class="wrapper-compare-item px-md-3">
                          <div class="d-flex">
                            <div class="row pl-2 icon-container"
                                 v-if="!item.selectedColor.samplesInfo.length > 0">
                              <div class="mx-2 mb-2"
                                   @mouseover="mouseover(index + '-compare')"
                                   @mouseleave="mouseleave">
                                <span class="png-icon png-icon-icons-symbols--r-txtinfo"></span>
                              </div>
                            </div>
                            <div id="hovercard"
                                 v-if="!item.selectedColor.samplesInfo.length > 0"
                                 class="rating-content-card m-0"
                                 v-show="index + '-compare' == showCard"
                                 @mouseover="mouseover(index + '-compare')"
                                 @mouseleave="mouseleave">
                              <div class="description text-uppercase"
                                   v-if="
                                   !item.selectedColor.samplesInfo.length>
                                0
                                "
                                >
                                <strong>
                                  STOCK Error
                                </strong>
                                <p class="mb-0">
                                  {{
                                    $resourceString[
                                      "pages.basket.errors.noavailablesize"
                                    ]
                                  }}
                                </p>
                              </div>
                            </div>


                            <a class="btn btn-white px-0 my-1 ml-auto"
                               @click="
                                removeCompareProduct(item.sellingStyleNumber)
                              ">
                              <span class="mr-3">
                                {{ $resourceString["common.remove"] }}
                              </span>
                              <span class="png-icon png-icon-icons-glyph--k-close" />
                            </a>
                          </div>
                          <div class="pop-up-compare-div-image mb-3">
                            <img alt="00100"
                                 @error="handleImageError"
                                 :src="item.selectedColor.imagePath"
                                 class="image-compare w-100" />
                          </div>
                          <dl class="description text-uppercase">
                            <div>
                              <dt>
                                <u>{{ item.selectedColor.colorName }}</u>
                              </dt>
                              <dd>
                                {{ item.selectedColor.colorNumber }}
                              </dd>
                            </div>
                            <div>
                              <dt>
                                {{
                                  $resourceString[
                                    "product.details.specifications.product.style"
                                  ]
                                }}
                              </dt>
                              <dd>
                                {{ item.sellingStyleName }}
                              </dd>
                            </div>
                            <div>
                              <dt>
                                {{
                                  $resourceString[
                                    "product.details.specifications.product.collection"
                                  ]
                                }}
                              </dt>
                              <dd>
                                {{ item.collection }}
                              </dd>
                            </div>
                            <div class="swatches-part">
                              <p class="swatch-title text-uppercase">
                                <b>{{ item.colors.length }}</b>
                                {{
                                  $resourceString[
                                    "product.details.room.scene.swatch.colors"
                                  ]
                                }}
                              </p>
                              <div class="swatch-image-section row">
                                <div class="col-4 swatch-image-item px-1"
                                     v-for="color in item.colors"
                                     :key="color.colorName + color.colorNumber">
                                  <button class="btn wf-product-room-scene-color-item-button"
                                          type="button"
                                          :class="
                                      color.colorNumber ===
                                      item.selectedColor.colorNumber
                                        ? 'wf-product-room-scene-color-item-button-active'
                                        : 'wf-product-room-scene-color-item-button-disabled'
                                    "
                                          @click="updateColor(index, color)">
                                    <img class="w-100 h-100"
                                         @error="handleImageError"
                                         :src="
                                        $helpers.getColorThumbnailImageUrl(
                                          item.sellingStyleNumber,
                                          color.colorNumber
                                        )
                                      "
                                         alt="" />
                                    <div class="wf-product-room-scene-color-item-name">
                                      {{
                                        color.colorName +
                                          (color.customIsDisclaimerColor
                                            ? "*"
                                            : "")
                                      }}
                                      <br />
                                      {{ color.colorNumber }}
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div v-show="viewMore" id="viewMoreCard">
                              <div class="specification-part mt-4">
                                <h3 class="label my-2">
                                  {{
                                    $resourceString[
                                      "product.details.specifications.specifications"
                                    ]
                                  }}
                                </h3>
                                <div v-if="item.inventorySubType">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.product.category"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.inventorySubType }}
                                  </dd>
                                </div>
                                <div v-if="item.inventoryType">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.product.type"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.inventoryType }}
                                  </dd>
                                </div>
                                <div v-if="item.secondaryBacking">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.secondary.backing"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.secondaryBacking }}
                                  </dd>
                                </div>
                                <div v-if="item.construction">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.construction"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.construction }}
                                  </dd>
                                </div>
                                <div v-if="item.testResults.tarrClassification">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.wear.rating"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.testResults.tarrClassification }}
                                  </dd>
                                </div>
                                <div v-if="item.dyeMethod">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.dye.method"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.dyeMethod }}
                                  </dd>
                                </div>
                                <div v-if="item.fiber">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.fiber"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{ item.fiber }}
                                  </dd>
                                </div>
                                <div v-if="item.areaPerCarton">
                                  <dt>
                                    {{
                                      $resourceString[
                                        "product.details.specifications.squareyards"
                                      ]
                                    }}
                                  </dt>
                                  <dd>
                                    {{
                                      Math.round(
                                        item.areaPerCarton.metric
                                          .formattedValue * 100
                                      ) / 100
                                    }}
                                  </dd>
                                </div>
                              </div>
                              <div class="pdq-part mt-4"
                                   v-if="item.selectedColor.colorCustomData.pdqId">
                                <h3 class="label my-2">
                                  {{
                                    $resourceString[
                                      "product.details.specifications.pdq.details"
                                    ]
                                  }}
                                </h3>
                                <dd v-html="item.pdqDetails" />
                              </div>
                              <div class="sustain-part mt-4"
                                   v-if="item.recyclability">
                                <h3 class="label my-2">
                                  {{
                                    $resourceString[
                                      "product.details.specifications.sustainability"
                                    ]
                                  }}
                                </h3>
                                <dt>
                                  {{
                                    $resourceString[
                                      "product.details.specifications.recyclability"
                                    ]
                                  }}
                                </dt>
                                <dd>
                                  {{ item.recyclability }}
                                </dd>
                              </div>
                              <div class="third-party-part mt-4"
                                   v-if="item.attributes">
                                <h3 class="label my-2">
                                  {{
                                    $resourceString[
                                      "product.details.specifications.third.party.certificates"
                                    ]
                                  }}
                                </h3>
                                <div class="third-party-items mb-2"
                                     v-if="item.attributes.length > 0"
                                     v-for="attribute in item.attributes"
                                     :key="attribute.name">
                                  <dt v-if="attribute.pdfLink">
                                    {{ attribute.name }}
                                  </dt>
                                  <dd v-if="attribute.pdfLink">
                                    <u>
                                      {{ attribute.status }}
                                    </u>
                                  </dd>
                                </div>

                                <div class="third-party-items mb-2"
                                     v-if="item.certifications.length > 0"
                                     v-for="certification in item.certifications"
                                     :key="certification.name">
                                  <dt v-if="certification.pdfLink">
                                    {{ certification.name }}
                                  </dt>
                                  <dd v-if="certification.pdfLink">
                                    <u>
                                      {{ certification.status }}
                                    </u>
                                  </dd>
                                </div>

                              </div>
                            </div>
                          </dl>
                        </div>
                      </div>
                    </VueSlickCarousel>
                    <div class="view-more-and-less-btn pt-4 px-5">
                      <div v-show="!viewMore">
                        <a @click="updateView(true)" class="view_more_pop-up">
                          {{
                            $resourceString[
                              "product.search.side.filters.view.more"
                            ]
                          }}
                          <span class="png-icon png-icon-icons-glyph--k-btn-expand-ol wf-product-refinement-list-header-toggle-active" />
                        </a>
                      </div>
                      <div v-show="viewMore">
                        <a @click="updateView(false)" class="view_less_pop-up">
                          {{
                            $resourceString[
                              "product.search.side.filters.view.less"
                            ]
                          }}
                          <span class="png-icon png-icon-icons-glyph--k-btn-minus-active wf-product-refinement-list-header-toggle-inactive" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="position:relative;">
              <pc-search-pdf-popup :showPopup="showPdfPopup" @close="closePdfPopup" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import VueSlickCarousel from "vue-slick-carousel";
  import html2canvas from "html2canvas";
  import FileSaver from "file-saver";
  import "vue-slick-carousel/dist/vue-slick-carousel.css";
  import { globalIcons } from "../../../constants/global";
  import PcPdfPopup from "./pc-product-pdf-popup.vue";
  import patcraftApi from "../../../scripts/patcraft-api";
  export default {
    data() {
      return {
        showCard: 0,
        defaultImage: globalIcons.defaultImage,
        viewMore: false,
        showPdfPopup: false,
        allowPdfRender: false,
        authenticated: false,
        settings: {
          centerMode: false,
          centerPadding: "20px",
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        },
        getCompareProductsSrc: [],
        flash: false,
        flashTick: null
      };
    },
    components: { VueSlickCarousel, 'pc-search-pdf-popup': PcPdfPopup },
    computed: {
      ...mapGetters({
        open: "compareModal/open",
        getCompareProducts: "productDetail/getCompareProducts",
        fetchingCompareProducts: "productDetail/fetchingCompareProducts",
        OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
        getCompareUrl: "productDetail/getCompareUrlLocal",
        getShowPdfPopup: "compareModal/getShowPdfPopup",
      }),
      disableAddToCart() {
        const hasResinousProduct = this.getCompareProducts.some(product => 
          product.inventoryType === this.$resourceString["resinous.InventoryType"]);
        return this.OrderSampleEnabled || hasResinousProduct;
      },
      checkSampleAvailability() {
        let sampleExists = this.getCompareProducts.find(
          e => e.selectedColor.samplesInfo.length == 0
        );
        if (sampleExists) return true;
        else return false;
      },
      selectedStyleNumbers() {
        const sellingStyleNumbers = this.getCompareProducts.map(product => product.sellingStyleNumber);
        return { SellingStyleNumbers: sellingStyleNumbers };
      }
    },
    methods: {
      ...mapActions({
        close: "compareModal/close",
        removeAllCompareProducts: "productDetail/removeAllCompareProducts",
        copyCompareUrl: "productDetail/copyCompareUrl",
        setCompareUrl: "productDetail/setCompareUrl",
        addCompareToBasket: "compareModal/addCompareToBasket",
        removeCompareProducts: "productDetail/removeCompareProducts",
        isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
        showCompareContent: "compareModal/showCompareContent"
      }),
      handleImageError(event) {
        event.target.src = this.defaultImage;
      },

      pdfDownload() {
        if (!this.getShowPdfPopup && !this.authenticated) {
          this.setCompareUrl();
          const decodedParam = decodeURIComponent(this.getCompareUrl);
          const url = '/Account/RequestSignIn?returnUrl=' + encodeURIComponent(decodedParam + '&DownloadDocs=true');
          window.location.href = url;
        }
        else {
          this.showPdfPopup = true;
          const sellingStyleNumbers = this.selectedStyleNumbers.SellingStyleNumbers.join(',');
          patcraftApi.getDocuments(sellingStyleNumbers);
        }
      },
      closePdfPopup() {
        this.showPdfPopup = false;
      },
      mouseover(item) {
        this.showCard = item;
      },
      mouseleave(event) {
        this.showCard = 0;
      },
      closeModal() {
        this.viewMore = false;
        this.showCompareContent(false);
        this.close();
      },
      removeAllCompareProduct: function () {
        this.removeAllCompareProducts();
        this.close();
      },
      copyComparisonUrl: function () {
        this.setCompareUrl();
        this.copyCompareUrl();
        this.flash = true;
      },
      removeCompareProduct: function (styleNumber) {
        this.removeCompareProducts(styleNumber);
        if (this.getCompareProducts.length < 2) {
          this.close();
        }
      },
      updateColor(index, color) {
        this.getCompareProducts[index]["selectedColor"] = color;
      },
      updateView(status) {
        document.querySelector(".modal.show.fade").scrollTo(0, 500);
        this.viewMore = status;
      },
      addToCart() {
        let basketItems = [];
        this.getCompareProducts.forEach(e => {
          let item = {
            isTrayItem: false,
            quantity: 1,
            sellingColorNumber: e.selectedColor.colorNumber,
            sellingStyleNumber: e.sellingStyleNumber,
            vehicleId: e.selectedColor.samplesInfo[0]
              ? e.selectedColor.samplesInfo[0].vehicleId
              : null
          };
          basketItems.push(item);
        });
        this.addCompareToBasket(basketItems);
      },
      // Start: Download option of compare products
      downloadProducts() {
        if (!this.getCompareProducts.length) {
          return;
        }
        this.showCompareContent(true).then((resp) => {
          this.downloadCanvas();
        });
      },

      downloadCanvas() {
        html2canvas(document.querySelector("#outer-wrapper"), {
          allowTaint: true,
          useCORS: true
        }).then(canvas => {
          canvas.toBlob(blob => {
            FileSaver.saveAs(blob, "patcraft-samples.png");
          });
        });
      },
      // End: Download option of compare products
      clearTick() {
        if (this.flashTick) {
          window.clearTimeout(this.flashTick);
        }
        this.flashTick = null;
      },
      async setPdfRenderVisible() {
        await patcraftApi.allowPdfRender().then(result => {
          this.allowPdfRender = result.data;
        });
      },
      isAuthenticated() {
        patcraftApi.isAuthenticated().then(result => {
          this.authenticated = result.data;
          if (this.getShowPdfPopup && this.authenticated) {
            this.showPdfPopup = this.getShowPdfPopup;
            this.pdfDownload();
          }
        });
      }
    },
    mounted: function() {
      this.setPdfRenderVisible();
      this.isAuthenticated();
    },
    watch: {
      flash: function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.clearTick();
          this.flashTick = window.setTimeout(() => {
            this.flash = false;
          }, 3000);
        }
      }
    },
    beforeDestroy() {
      this.clearTick();
    },
    created() {
      this.isOrderSampleEnabled();
    }
  };
</script>
